module.exports = __webpack_public_path__ + "media/images/emoticons/sign02-669203d6cba5130e1afc6872d594fbc1.gif";